import { render, staticRenderFns } from "./emc1.vue?vue&type=template&id=5594c3f6"
import script from "./emc1.vue?vue&type=script&lang=js"
export * from "./emc1.vue?vue&type=script&lang=js"
import style0 from "./emc1.vue?vue&type=style&index=0&id=5594c3f6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports